const reais = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const inteiro = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 0 });
const pct = new Intl.NumberFormat('pt-BR', { minimumFractionDigits: 1, maximumFractionDigits: 1 });

export const fmtReais = (v: number) => reais.format(v);
export const fmtInteiro = (v: number) => inteiro.format(v);
/** Eixo de gráfico: R$ 12 mil, R$ 1,2 mi. Só no eixo; número de leitura vai inteiro. */
export const fmtEixoReais = (v: number) => {
  const a = Math.abs(v);
  if (a >= 1e6) return `R$ ${pct.format(v / 1e6)} mi`;
  if (a >= 1e3) return `R$ ${inteiro.format(v / 1e3)} mil`;
  return `R$ ${inteiro.format(v)}`;
};

const curto = new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 });
/** Valor abreviado para tabela densa (R$ 51,3K, -R$ 1,2M); o inteiro vai no title. Pedido para a liability. */
export const fmtReaisCurto = (v: number) => {
  const a = Math.abs(v);
  const s = v < 0 ? '-' : '';
  if (a >= 1e6) return `${s}R$ ${curto.format(a / 1e6)}M`;
  if (a >= 1e3) return `${s}R$ ${curto.format(a / 1e3)}K`;
  return `${s}R$ ${inteiro.format(a)}`;
};

/** "12/10" para eixo e "12/10/2026 (seg)" para tabela. */
export const fmtDiaCurto = (d: string) => `${d.slice(8, 10)}/${d.slice(5, 7)}`;
const semana = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
export const fmtDia = (d: string) =>
  `${d.slice(8, 10)}/${d.slice(5, 7)}/${d.slice(0, 4)} (${semana[new Date(`${d}T12:00:00Z`).getUTCDay()]})`;

const hora = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', hour: '2-digit', minute: '2-digit' });
const horaSeg = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', hour: '2-digit', minute: '2-digit', second: '2-digit' });
const dataHora = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
const data = new Intl.DateTimeFormat('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric' });
/** "21/10/2026 21:36" e "21/10/2026" no horário de Brasília, a partir de um instante ISO. */
export const fmtDataHora = (iso: string) => dataHora.format(new Date(iso)).replace(',', '');
export const fmtData = (iso: string) => data.format(new Date(iso));
/** "21:36" no horário de Brasília, a partir de um instante ISO. */
export const fmtHora = (iso: string) => hora.format(new Date(iso));
export const fmtHoraSeg = (iso: string) => horaSeg.format(new Date(iso));
export const fmtPct = (v: number) => `${pct.format(v)}%`;

export interface Variacao {
  texto: string;
  sentido: 'sobe' | 'desce' | 'igual' | 'sem-base';
}

/** "▲ 12,3% vs período anterior". Sem base (anterior = 0) não inventa percentual. */
export function variacao(atual: number, anterior: number, rotulo = 'vs período anterior'): Variacao {
  if (anterior === 0) return { texto: atual === 0 ? `sem movimento ${rotulo.replace('vs ', 'no ')}` : `sem base ${rotulo.replace('vs ', 'no ')}`, sentido: 'sem-base' };
  const v = ((atual - anterior) / Math.abs(anterior)) * 100;
  if (Math.abs(v) < 0.05) return { texto: `= igual ${rotulo.replace('vs ', 'ao ')}`, sentido: 'igual' };
  return { texto: `${v > 0 ? '▲' : '▼'} ${pct.format(Math.abs(v))}% ${rotulo}`, sentido: v > 0 ? 'sobe' : 'desce' };
}

export const fmtDuracao = (s: number) => {
  if (s < 90) return `${s} s`;
  if (s < 5400) return `${Math.round(s / 60)} min`;
  return `${pct.format(s / 3600)} h`;
};
